import { Plan } from "../types";
import { formatPriceCurrency } from "../utils/formatPriceCurrency";
export type PricingData = {
    id: "pro" | "business";
    title: string;
    features: string[];
    currency_price_monthly: string;
    currency_price_yearly: string;
    hasMinUsers: boolean;
};

export function usePricingData(plans: Plan[]) {
    console.log(plans);

    const monthlyPro = plans.find(
        (plan) =>
            plan.id === "ZAPTIME_PRO_MONTHLY_CZK" ||
            plan.id === "ZAPTIME_PRO_MONTHLY_EUR",
    );
    const yearlyPro = plans.find(
        (plan) =>
            plan.id === "ZAPTIME_PRO_YEARLY_CZK" ||
            plan.id === "ZAPTIME_PRO_YEARLY_EUR",
    );

    if (monthlyPro === undefined || yearlyPro === undefined) {
        throw new Error("Plan not found");
    }

    const pro: PricingData = {
        title: "Professional Yearly",
        id: "pro",
        currency_price_monthly: formatPriceCurrency(
            monthlyPro.price,
            monthlyPro.currency,
        ),
        currency_price_yearly: formatPriceCurrency(
            yearlyPro.price / 12,
            yearlyPro.currency,
        ),
        hasMinUsers: false,
        features: [
            "Unlimited Event Types",
            "Unlimited Availabilities",
            "Unlimited Custom Workflows",
            "Unlimited Appearances",
            "Remove Zaptime branding",
            "Access to all integrations",
            "Custom sending domain",
            "Google Analytics / Meta Pixel",

            // "Round robin",
            // "Team workflows",
        ],
    };

    const business: PricingData = {
        id: "business",
        title: "Business",
        currency_price_monthly: "$34",
        currency_price_yearly: "$28",
        hasMinUsers: true,
        features: [
            "Everything in Professional",
            "Unlimited Sending Domains",
            "Unlimited Custom Domains",
            "Dedicated onboarding",
            "Developer support",
            "Extensive whitelabeling",
            "Vue components SDK",
            "Booking API endpoints",
            // "SAML SSO",
            // "Advanced analytics",
            // "Platform API endpoints",
        ],
    };

    return {
        pro,
        business,
    };
}
